import { useEffect, useState } from 'react'

// 数値入力（フォーカス中はドラフトを保持し、blur / Enter で確定する）
export default function NumberField({
  value,
  step,
  min,
  onCommit,
  disabled = false,
}: {
  value: number
  step: number
  min?: number
  onCommit: (value: number) => void
  disabled?: boolean
}) {
  const [draft, setDraft] = useState(String(value))
  const [editing, setEditing] = useState(false)

  useEffect(() => {
    if (!editing) setDraft(String(value))
  }, [value, editing])

  const commit = () => {
    setEditing(false)
    const v = parseFloat(draft)
    if (Number.isFinite(v)) {
      onCommit(v)
    } else {
      setDraft(String(value))
    }
  }

  return (
    <input
      type="number"
      value={draft}
      step={step}
      min={min}
      disabled={disabled}
      onFocus={() => setEditing(true)}
      onChange={(e) => setDraft(e.target.value)}
      onBlur={commit}
      onKeyDown={(e) => {
        if (e.key === 'Enter') (e.target as HTMLInputElement).blur()
      }}
      className="w-full px-2 py-1 text-xs border border-gray-300 rounded tabular-nums focus:outline-none focus:ring-1 focus:ring-blue-400 focus:border-blue-400 disabled:bg-gray-100 disabled:text-gray-400"
    />
  )
}
